/**
 * Shared role → portal routing and portal permission maps.
 * Keep PortalGuard, LoginForm, AuthScreen, and related UI in sync via this module.
 */

export const ROLE_HOME: Record<string, string> = {
  ceo: '/ceo-portal',
  admin: '/admin-portal',
  finance: '/finance-portal',
  operations: '/operations-portal',
  team_leader: '/team-leader-portal',
  member: '/member-portal',
};

/** Alias used by login / change-password flows */
export const ROLE_ROUTES = ROLE_HOME;

/** Maps each portal to the roles that are permitted to access it. */
export const PORTAL_PERMISSIONS: Record<string, string[]> = {
  'ceo-portal': ['ceo'],
  'admin-portal': ['ceo', 'admin'],
  'finance-portal': ['ceo', 'finance'],
  'operations-portal': ['ceo', 'operations'],
  'team-leader-portal': ['ceo', 'team_leader'],
  'member-portal': ['ceo', 'member'],
};

/**
 * Normalize role strings from DB / JWT (case, separators, aliases)
 * so PortalGuard lookups never miss due to "CEO" vs "ceo".
 */
export function normalizeRole(role: string | null | undefined): string | null {
  if (!role || typeof role !== 'string') return null;
  let r = role.trim().toLowerCase().replace(/[-\s]+/g, '_');
  if (r === 'teamleader') r = 'team_leader';
  if (r === 'team_lead') r = 'team_leader';
  return r || null;
}

export function getRoleHome(role: string | null | undefined): string {
  const normalized = normalizeRole(role);
  if (!normalized) return '/sign-up-login-screen';
  return ROLE_HOME[normalized] ?? '/member-portal';
}

export function isKnownRole(role: string | null | undefined): boolean {
  const normalized = normalizeRole(role);
  return normalized !== null && Object.prototype.hasOwnProperty.call(ROLE_HOME, normalized);
}
